<mat-dialog-content class="p-4 dark-bg  dark-mode">
    <h3 style="font-size: 25px;" class="text-white">Search by Filter</h3>
    <form [formGroup]="form">
        <div class="row mt-5">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Join Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="createDate">
                    <mat-datepicker-toggle class="text-white" matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Account Type</mat-label>
                    <mat-select multiple formControlName="accountType" (selectionChange)="onOptionChange($event)">
                        <mat-select-trigger>
                            <mat-chip-set *ngIf="form.controls.accountType.value?.length">
                                <mat-chip style="background: #F7F2FF;" *ngFor="let option of form.controls.accountType.value" [removable]="true" (removed)="removeOption(option)">
                                    <span>{{ option }}</span>
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </mat-chip-set>
                            <span *ngIf="!form.controls.accountType.value?.length">Select Account Type...</span>
                        </mat-select-trigger>

                        <mat-option *ngFor="let product of data?.products" [value]="product.stripeProductId">
                            {{ product.productName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>User Role</mat-label>
                    <mat-select multiple formControlName="userRole" (selectionChange)="onRoleChange($event)">
                        <mat-select-trigger>
                            <mat-chip-set *ngIf="form.controls.userRole.value?.length">
                                <mat-chip style="background: #F7F2FF;" *ngFor="let option of form.controls.userRole.value" [removable]="true" (removed)="removeOptionRole(option)">
                                    <span>{{ option }}</span>
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </mat-chip-set>
                            <span *ngIf="!form.controls.userRole.value?.length">Select User Role...</span>
                        </mat-select-trigger>

                        <mat-option *ngFor="let role of data?.userRoles" [value]="role.name">
                            {{ role.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>


    </form>
</mat-dialog-content>
<mat-dialog-actions class=" dark-mode p-4 justify-content-end dark-bg">
    <button mat-raised-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="warn" (click)="resetForm()">Reset</button>
    <button mat-raised-button class="bg-accent-orange" (click)="applyFilter()">Apply</button>
</mat-dialog-actions>
